// Footer.js
import React from "react";
import "./Footer.css";

const Footer = () => {
    return (
        <div className="footer-container">
            <div className="footer-content">
                <div className="footer-description">
                    Design by. Linear<br />
                    Icon made by <a href="https://www.flaticon.com/">Flat Icons</a><br />
                </div>
            </div>
        </div>
    );
};

export default Footer;
